import Container from "@material-ui/core/Container";
import styled from "styled-components";

const StyledContainer = styled(Container)`
  background: transparent;
`;

export default StyledContainer;
